module.exports = __webpack_public_path__ + "static/img/system-3.42aacb88.png";